export default __webpack_public_path__ + "static/media/LeeaLogo.69eaa5e6.svg";